import React from 'react';

import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table';

import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import './styles.scoped.css';
import { TablePagination } from '../../../components';
import { money } from '../../../utils';

const columnClassName = 'align-middle text-nowrap';

export const arAgingColumns = [
  {
    Header: 'Bill To#',
    accessor: 'BillToNumber',
    className: columnClassName,
  },
  {
    Header: 'Customer Info',
    accessor: 'CustomerInfo',
    className: columnClassName,
  },
  {
    Header: 'Customer Info2',
    accessor: 'CustomerInfo2',
    className: columnClassName,
  },
  {
    Header: 'Invoice #',
    accessor: 'Invoice_Number',
    className: columnClassName,
  },
  {
    Header: 'Trans Date',
    accessor: 'Trans_Date',
    className: columnClassName,
  },
  {
    Header: 'Trans Code',
    accessor: 'Trans_Code',
    className: columnClassName,
  },
  {
    Header: 'Transaction Amount',
    accessor: 'Trans_Amount',
    className: columnClassName,
    Cell: instance => money.format(instance.value),
  },
  {
    Header: 'Transaction Balance',
    accessor: 'Trans_Balance',
    className: columnClassName,
    Cell: instance => money.format(instance.value),
  },
  {
    Header: '0-30 Aging',
    accessor: 'Aging_Thirty',
    className: columnClassName,
  },
  {
    Header: '31-60 Aging',
    accessor: 'Aging_Sixty',
    className: columnClassName,
  },
  {
    Header: '61-90 Aging',
    accessor: 'Aging_Nighty',
    className: columnClassName,
  },
  {
    Header: 'Over 90 Aging',
    accessor: 'Aging_Over_Nighty',
    className: columnClassName,
  },
  {
    Header: 'Cash On Account',
    accessor: 'Cash_On_Account',
    className: columnClassName,
  },
  {
    Header: 'Future On Account',
    accessor: 'Future_On_Account',
    className: columnClassName,
  },
  {
    Header: 'FUTURE',
    accessor: 'Future',
    className: columnClassName,
  },
  {
    Header: 'Aging Date',
    accessor: 'Aging_Date',
    className: columnClassName,
  },
  {
    Header: 'Branch',
    accessor: 'Branch',
    className: columnClassName,
  },
  {
    Header: 'AMC',
    accessor: 'AMC',
    className: columnClassName,
  },
  {
    Header: 'PERMINV',
    accessor: 'Perm_Inv',
    className: columnClassName,
  },
  {
    Header: 'Month End',
    accessor: 'Month_End',
    className: columnClassName,
  },
  {
    Header: 'Credit Limit',
    accessor: 'Credit_Limit',
    className: columnClassName,
    Cell: instance => money.format(instance.value),
  },
  {
    Header: 'BillTo Counter',
    accessor: 'Bill_To_Counter',
    className: columnClassName,
  },
  {
    Header: 'Avg Days Pay',
    accessor: 'Avg_Days_Pay',
    className: columnClassName,
  },
  {
    Header: 'DS Amt30',
    accessor: 'DS_Amount_Thirty',
    className: columnClassName,
  },
  {
    Header: 'DS Amt60',
    accessor: 'DS_Amount_Sixty',
    className: columnClassName,
  },
  {
    Header: 'DS Amt90',
    accessor: 'DS_Amount_Nighty',
    className: columnClassName,
  },
  {
    Header: 'DS OverAmt90',
    accessor: 'DS_Amount_Over_Nighty',
    className: columnClassName,
  },
  {
    Header: 'Header Sort Name',
    accessor: 'Header_Sort_Name',
    className: columnClassName,
  },
  {
    Header: 'Footer Sort Name',
    accessor: 'Footer_Sort_Name',
    className: columnClassName,
  },
  {
    Header: 'Sort Value',
    accessor: 'Sort_Value',
    className: columnClassName,
  },
  {
    Header: 'TPC',
    accessor: 'TPC',
    className: columnClassName,
  },
  {
    Header: 'Customer Info3',
    accessor: 'CustomerInfo3',
    className: columnClassName,
  },
  {
    Header: 'Customer Info4',
    accessor: 'CustomerInfo4',
    className: columnClassName,
  },
  {
    Header: 'Customer Info5',
    accessor: 'CustomerInfo5',
    className: columnClassName,
  },
  {
    Header: 'YTD Sales',
    accessor: 'YTD_Sales',
    className: columnClassName,
  },
  {
    Header: 'BillTo Name',
    accessor: 'BillTo_Name',
    className: columnClassName,
  },
  {
    Header: 'Last Pay Date',
    accessor: 'Last_Pay_Date',
    className: columnClassName,
  },
  {
    Header: 'Avg Pay',
    accessor: 'Avg_Pay',
    className: columnClassName,
  },
  {
    Header: 'CustName Number',
    accessor: 'CustName_Number',
    className: columnClassName,
  },
  {
    Header: 'Display Number',
    accessor: 'Display_Number',
    className: columnClassName,
  },
  {
    Header: 'Display Date',
    accessor: 'Display_Date',
    className: columnClassName,
  },
  {
    Header: 'Customer Info6',
    accessor: 'CustomerInfo6',
    className: columnClassName,
  },
  {
    Header: 'Customer Info7',
    accessor: 'CustomerInfo7',
    className: columnClassName,
  },
  {
    Header: 'Document Gross Amount DISPLAY',
    accessor: 'Document_Gross_Amount_Display',
    className: columnClassName,
  },
  {
    Header: 'AMC CODE',
    accessor: 'Amc_Code',
    className: columnClassName,
  },
  {
    Header: 'LOB',
    accessor: 'LOB',
    className: columnClassName,
  },
  {
    Header: 'Job Branch',
    accessor: 'JobBranch',
    className: columnClassName,
  },
];

function getSortedIcon(isSorted, isSortedDesc) {
  let iconProp = <FaSort />;
  if (isSorted) {
    iconProp = isSortedDesc ? <FaSortDown /> : <FaSortUp />;
  }
  return iconProp;
}

const ARAgingReportTableHistorical = ({ data, loading }) => {
  const tableInstance = useTable(
    {
      columns: arAgingColumns,
      data,
      initialState: {
        pageSize: 200,
        sortBy: [
          {
            id: 'CreatedAt',
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  const tableHeaders = headerGroups.map(headerGroup => {
    const headers = headerGroup.headers.map(column => (
      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
        {column.render('Header')}
        <span>
          {column.canSort
            ? getSortedIcon(column.isSorted, column.isSortedDesc)
            : null}
        </span>
      </th>
    ));
    return <tr {...headerGroup.getHeaderGroupProps()}>{headers}</tr>;
  });

  const tableRows = page.map(row => {
    prepareRow(row);
    const cells = row.cells.map(cell => (
      <td
        {...cell.getCellProps({
          className: cell.column.className,
          style: cell.column.style,
        })}
      >
        {cell.render('Cell')}
      </td>
    ));

    return <tr {...row.getRowProps()}>{cells}</tr>;
  });

  return (
    <Container fluid>
      <Row className="align-items-center">
        <Col className="d-flex justify-content-center justify-content-md-end">
          <TablePagination tableInstance={tableInstance} />
        </Col>
      </Row>
      <Row>
        <Col className="border border-light rounded shadow-sm">
          <Table hover responsive borderless {...getTableProps()}>
            <thead className="text-nowrap">{tableHeaders}</thead>
            <tbody {...getTableBodyProps()}>{tableRows}</tbody>
          </Table>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading && <Spinner animation="border" />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ARAgingReportTableHistorical;
